module.exports = __webpack_public_path__ + "media/images/sp/plans/mv_flower-ad21c74a1dca244d712535832e627742.webp";